export type TableSelectionMeta = {
  selectedKeys: string[];
  isAllPagesSelected: boolean;
  uncheckedIds: string[];
  totalCount: number;
};

/** Legacy DynamicTable parity — toolbar actions gated on row selection. */
export function computeHasSelectedItems(meta: TableSelectionMeta): boolean {
  if (meta.isAllPagesSelected) {
    return meta.totalCount - meta.uncheckedIds.length > 0;
  }
  return meta.selectedKeys.length > 0;
}

export function resolveSelectedRows(
  selectedKeys: string[],
  displayData: unknown[],
  resolveRowKey: (row: Record<string, unknown>, rowIndex: number) => string,
): Record<string, unknown>[] {
  if (selectedKeys.length === 0) return [];

  const keySet = new Set(selectedKeys);
  const rows: Record<string, unknown>[] = [];

  (displayData as Record<string, unknown>[]).forEach((row, index) => {
    const key = resolveRowKey(row, index);
    if (keySet.has(key)) {
      rows.push(row);
    }
  });

  return rows;
}
